import ModalDialog from '@stone/components/modal/ModalDialog';
import useQueryStringBoolean from '@utils/useQueryStringBoolean';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
const CorporateModal = (props) => {
    const { t } = useTranslation();
    const [open, setOpen] = useQueryStringBoolean('localeselector');
    useEffect(() => { }, [open]);
    const modal = () => (React.createElement(ModalDialog, { contentLabel: t('footer.corporateinfo'), isOpen: open, hasDivisor: true, onRequestClose: () => {
            setOpen(false);
        } },
        React.createElement("div", { className: "mt-32", dangerouslySetInnerHTML: { __html: t(`footer.${props.region}`) } })));
    return (React.createElement(React.Fragment, null,
        "-",
        ' ',
        React.createElement("button", { type: "button", onClick: () => setOpen(true), "aria-haspopup": "dialog", className: "button button--tertiary inverted" },
            React.createElement("span", null, t('footer.corporateinfo'))),
        modal()));
};
export default CorporateModal;
